import TagManager, { DataLayerArgs, TagManagerArgs } from 'react-gtm-module'

import {
  TagManagerAction,
  TagManagerEventType,
  TagManagerPage,
} from '~/platform/utils/googleTagManager/tagManagerModels'

export const initializeTagManager = () => {
  const tagManagerArgs: TagManagerArgs = {
    gtmId: import.meta.env.VITE_GTM_ID,
  }

  TagManager.initialize(tagManagerArgs)
}

export const triggerTagManagerEvent = (
  event: TagManagerEventType,
  action?: TagManagerAction,
  page?: TagManagerPage,
) => {
  const tagManagerEventArgs: DataLayerArgs = {
    dataLayer: {
      ...(page && { page }),
      event,
      ...(action && { action }),
    },
  }
  try {
    TagManager.dataLayer(tagManagerEventArgs)
  } catch {
    // Analytics must never take out what the visitor is doing. Widgets embed on
    // pages that may not have GTM, and with no dataLayer present the library
    // falls back to injecting a snippet, which can throw; without this guard
    // that exception propagates out of the click handler that reported the
    // event and the action itself never happens.
  }
}
